import "core-js/modules/es6.number.constructor";
//
//
//
//
//
import init from '@/views/visual/dataScreen/mixins/';
import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
import '@/assets/avue-preview.css';
import Vue from 'vue';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
Vue.use(Avue, {
  size: 'mini'
});
export default {
  props: {
    option: Object,
    id: [String, Number]
  },
  mixins: [init],
  beforeCreate: function beforeCreate() {
    window.$website = {
      url: window.domainURL,
      isDemo: false,
      isDemoTip: '演示环境不允许操作'
    };
    Vue.prototype.$website = window.$website;
  }
};